<app-header *ngIf="route.game(route.current)===false"></app-header>
<div class="container-fluid main-wrapper"
[class.fullheight]="(route.game(route.current)===true)?true:false" >
  <router-outlet></router-outlet>
</div>
